function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { SimpleContainer, CssContainer } from "../../components/container";
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import ProductGrid from "../../components/product-grid";
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import { Button } from '@progress/kendo-react-buttons';
import Query from "../../functions/query";
import ServiceFactory from '../../service';
import ManageDataTabs from '../../components/manage-data-tabs';
import { manageDataLegacyHere } from '../../functions/tenant-features';
import ProductsKit from './products-kit';
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onButtonClick", event => {
      this.gotoPage('/Product/Update');
    });
    _defineProperty(this, "onSelected", e => {
      var item = e.detail.item;
      var range = item.dataset.value;
      this.setState({
        fetch: true,
        range: range,
        showLoader: true
      });
    });
  }
  componentDidMount() {
    publishSearch('Product');
    publishEvent('reset-search', {});
  }
  render() {
    var baseUrl = '/Product';
    var refreshUrl = '/Product';
    var data = this.props.data;
    if (!manageDataLegacyHere()) {
      return /*#__PURE__*/React.createElement(ProductsKit, {
        data: data,
        pagination: this.props.pagination,
        onUpdate: this.onButtonClick,
        gotoPage: p => this.gotoPage(p)
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view"
    }, /*#__PURE__*/React.createElement(CssContainer, {
      cls: "grid-button space-between margin-squeeze align-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "heading-label"
    }, "Manage Data"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: this.onButtonClick
    }, "Manage Product ", /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: '18px',
        verticalAlign: 'middle'
      }
    }, "arrow_forward"))), /*#__PURE__*/React.createElement(ManageDataTabs, {
      active: "/Product"
    }), /*#__PURE__*/React.createElement(SimpleContainer, {
      cls: "no-padding margin-squeeze"
    }, /*#__PURE__*/React.createElement(ProductGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: data,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest
    })));
  }
}
export class ProductViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  get api() {
    let query = this.queryParams;
    var api = '/product';
    let $where = query.get('$where');
    let $params = query.get('$params');
    $where = Query.WHERE($where);
    $params = Query.PARAMS($params);
    if ($where && $params) {
      api += '?$where=' + $where + '&$params=' + $params;
    }
    return api;
  }
  async fetchData() {
    let query = this.queryParams;
    let page = this.page;
    var api = this.api;
    var Service = ServiceFactory.getType(api, 'product');
    var service = new Service();
    var baseUrl = '/Product';
    try {
      // The kit catalog shows 25 rows a page; the legacy grid keeps 10.
      let data = await service.paginate({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: manageDataLegacyHere() ? 10 : 25
      }).orderBy(query.get('$orderBy')).orderByDesc(query.get('$orderByDesc')).getAsync();
      this.data = data.items;
      this.pagination = data.pagination;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  ProductViewComponent
};